class SuccessStoryTileSlider
    constructor: (el) ->
        @.$el = el
        @.$actualEl = @.$el.querySelector '.success-story-tile-slider__actual'
        @.$maxEl = @.$el.querySelector '.success-story-tile-slider__max'
        @.$nextButton = @.$el.querySelector '.success-story-tile-slider__next'
        @.$prevButton = @.$el.querySelector '.success-story-tile-slider__prev'
        @.$slider = @.$el.querySelector '.slider'
        @.$slides = @.$el.querySelectorAll '.success-story-tile-slider__slide'

        @.activeSlide = 0

        if @.$slides.length > 1
            @.$maxEl.innerHTML = @.$slides.length
            @.InitEvents()
        else if @.$slides.length > 0
            @.$el.classList.add 'success-story-tile-slider--hide-controls'
        else
            @.$el.remove()
            return
        @.$el.classList.add 'success-story-tile-slider--bound'
        return

    InitEvents: ->
        self = @
        @.$nextButton.addEventListener 'click', (e) ->
            self.$slider.dispatchEvent new CustomEvent 'slider-slide-to', {
                bubbles: false,
                detail: {
                    slide: self.activeSlide + 1
                }
            }
            return
        @.$prevButton.addEventListener 'click', (e) ->
            self.$slider.dispatchEvent new CustomEvent 'slider-slide-to', {
                bubbles: false,
                detail: {
                    slide: self.activeSlide - 1
                }
            }
            return
        @.$slider.addEventListener 'slider-slid', (e) ->
            activeSlide = e.detail?.activeSlide ? 0
            self.activeSlide = activeSlide
            self.$actualEl.innerHTML = self.activeSlide + 1
            return
        return

BindSuccessStoryTileSliders = ->
    document.querySelectorAll '.success-story-tile-slider:not(.success-story-tile-slider--bound)'
        .forEach (el) ->
            new SuccessStoryTileSlider el
            return
    return

window.addEventListener 'bind-components', BindSuccessStoryTileSliders